// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { PlacementFrontend } from '@post-office/browser--people-and-teams/teams-screen-space-flags';

import { MessageFrontend as createMessageFrontendTeamsAppChangeboardingPopups } from '@post-office/browser--people-and-teams/teams-app-changeboarding-popups/placements/in-app-v2/teams-screen-space-flags';

import { withI18n } from './i18n';

import { type PlacementRendererStage } from '@post-office/message-maker-browser/types';
import { type AppProps } from '@post-office/browser--people-and-teams/teams-screen-space-flags';
import { type ComponentType } from 'react';

const messageFrontends = [
	createMessageFrontendTeamsAppChangeboardingPopups({
		messageTemplateId: 'teams-app-changeboarding-popups',
	}),
];

export const RawPlacement: PlacementRendererStage<AppProps> =
	PlacementFrontend.createPlacementFrontendComponent({
		messageTemplates: messageFrontends,
	});

export const Placement: ComponentType<
	Omit<AppProps, 'ref'> & {
		ref?: unknown;
	}
> = withI18n(RawPlacement);

export const SSRPlacement: PlacementRendererStage<AppProps> = RawPlacement;
